export const CRONOS_TESTNET_TOKEN_LIST = {
  name: 'DmmExchange Token List',
  keywords: ['dmmexchange'],
  timestamp: '2020-12-12T00:00:00+00:00',
  tokens: [
    {
      chainId: 338,
      address: '0x868FC5cB3367C4A43c350b85D5001acaF58A857E',
      symbol: 'KNC',
      name: 'Kyber Network Crystal',
      decimals: 18,
    },
    {
      chainId: 338,
      address: '0x7D877Cde00D6575bd45E15Af64BA193e32A09743',
      symbol: 'ETH',
      name: 'Ether',
      decimals: 18,
    },
    {
      chainId: 338,
      address: '0x136ae5CC3150C4e53AF8b1DC886464CB9AF1AB61',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 338,
      address: '0x0b19552b293Be73D147159537706450B52f53a61',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 338,
      address: '0xFEC9C3feCB5f17A2C7b01492498D00966E623454',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 338,
      address: '0x1A46dCaC1d91F1731574BEfAEDaC4E0392726e35',
      symbol: 'WCRO',
      name: 'Wrapped CRO',
      decimals: 18,
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
